import {RecordTableColumnParams} from '../../../../types/records-table.types';
import {Pagination} from '../../../../types/pagable.types';

export const defaultPaginationData: Pagination = {
  number: Infinity,
  numberOfElements: Infinity,
  totalPages: Infinity,
  totalElements: Infinity,
  empty: false
}

const defaultColumnsParams: Omit<RecordTableColumnParams, 'name' | 'key' | 'type' | 'order'> = {
  columnProperties: {},
  sortable: false,
  sortField: null,
  editable: false,
  filterName: null,
  filterType: 'DEFAULT',
  filterable: false,
  omit: false,
  sticky: false,
  required: false,
  separated: false,
  link: false,
  enableBackgroundColour: false,
  width: null,
  metaGroup: '',
  metaSelectKeyList: null,
  inputValidations: [],
}

export const repeatsTableColumnConfig: Array<RecordTableColumnParams> = [
  {
    ...defaultColumnsParams,
    name: 'Id',
    key: 'id',
    type: 'TEXT',
    order: 1
  },
  {
    ...defaultColumnsParams,
    name: 'User Id',
    key: 'userId',
    type: 'TEXT',
    order: 2
  },
  {
    ...defaultColumnsParams,
    name: 'Планируемая дата',
    key: 'plannedDate',
    type: 'DATE',
    order: 3
  },
  {
    ...defaultColumnsParams,
    name: 'Имя канала',
    key: 'channelName',
    type: 'TEXT',
    order: 4
  },
  {
    ...defaultColumnsParams,
    name: 'Ссылка, где размещаем рекламу',
    key: 'channelUrl',
    type: 'TEXT',
    order: 5
  },
  {
    ...defaultColumnsParams,
    name: 'Менеджер',
    key: 'managerApproveId',
    type: 'TEXT',
    order: 6
  }
]
